import styled from "styled-components";
import { Button } from "../../atoms/Button";
import { FaceIdIcon } from "../../atoms/icons/easy_login/FaceIdIcon";
import { PassKeyIcon } from "../../atoms/icons/easy_login/PassKeyIcon";
import { QrCodeIcon } from "../../atoms/icons/easy_login/QrCodeIcon";
import { CardTemplate } from "../../templates/CardTemplate";
import { useEasyLogin } from "./hook";

export const EasyLoginPage: React.FC = () => {
  const { handleEasyLogin, handleSettingLater } = useEasyLogin();

  return (
    <CardTemplate title="ログインを簡単に行う">
      <StyledIconContainer>
        <FaceIdIcon />
        <PassKeyIcon />
        <QrCodeIcon />
      </StyledIconContainer>

      <StyledDescriptionContainer>
        <StyledTextContainer>
          パスキーを使用して本人確認を行うことができます。設定すると次回から、顔認証や指紋認証でログインすることができます。
          <br />
          <br />
          今ご使用の端末がご自身の端末である場合のみパスキーの設定を行ってください。
        </StyledTextContainer>
      </StyledDescriptionContainer>

      <StyledFooter>
        <Button
          text="パスキーを設定"
          variant="filled"
          onClick={handleEasyLogin}
          fullWidth
        />
        <Button
          variant="link"
          text="後で設定"
          type="button"
          onClick={handleSettingLater}
        />
      </StyledFooter>
    </CardTemplate>
  );
};

const StyledIconContainer = styled.div`
  display: flex;
  padding: 10px;
  justify-content: center;
  align-items: center;
  gap: 20px;
  flex: 1 0 0;
`;

const StyledDescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
`;

const StyledTextContainer = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
`;

const StyledFooter = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
